import { responsiveFontSizes, Theme } from "@mui/material/styles";
import theme from "./theme";
// import overrides from "./overrides";

const main: Theme = {
  ...theme,
};

export default responsiveFontSizes(main);
